<h5 class="p-3">Références</h5>

<div class="my-3 p-3 bg-white rounded shadow-sm">
  <div class="input-group mb-4">
    <input 
      type="text" 
      class="form-control" 
      placeholder="Recherche" 
      [(ngModel)]="searchRequest.query" 
      (keyup)="onSearchKeyup($event)"
      [attr.disabled]="loading || searchInProgress ? 'DISABLED' : null"
    />

    <author-search-criteria [loading]="loading" class="input-group-append"></author-search-criteria>
    
    <publisher-search-criteria [loading]="loading" class="input-group-append"></publisher-search-criteria>
    
    <genre-search-criteria [loading]="loading" class="input-group-append"></genre-search-criteria>

    <div class="input-group-append">
      <button class="btn btn-outline-secondary" type="button" [attr.disabled]="loading ? 'DISABLED' : null" (click)="querySearch()">
        <i *ngIf="!searchInProgress" class="bi bi-search"></i>
        <span *ngIf="searchInProgress" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
    </div>

    <button class="ml-3 btn btn-outline-primary" (click)="openNewReferenceModal()">Nouvelle référence</button>
  </div>

  <div class="btn-toolbar">
    <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('author').length > 0">
      <div class="input-group-prepend">
        <div class="btn btn-secondary btn-sm">{{ displayAuthorFilter() }}</div>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary btn-sm" type="button" (click)="clearAuthors()" >X</button>
      </div>
    </div>

    <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('genre').length > 0">
      <div class="input-group-prepend">
        <div class="btn btn-secondary btn-sm">{{ displayGenreFilterFr() }}</div>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary btn-sm" type="button" (click)="clearGenres()" >X</button>
      </div>
    </div>

    <div class="input-group pb-2" *ngIf="searchRequest.getValues('publisher').length > 0">
      <div class="input-group-prepend">
        <div class="btn btn-secondary btn-sm">{{ displayPublisherFilter() }}</div>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary btn-sm" type="button" (click)="clearPublishers()" >X</button>
      </div>
    </div>
  </div>

  <div class="border-bottom"></div>
  
  <search-paging [searchComponent]="this"></search-paging>

  <div class="mt-2 text-center" *ngIf="loading">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Chargement...
  </div>

  <table class="table table-sm" *ngIf="results">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>ISBN</th>
        <th>Titre</th>
        <th>Auteurs</th>
        <th>Éditeur</th>
        <th>Fournisseur</th>
        <th>Prix de vente</th>
        <th>Inventaire</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr reference-result *ngFor="let reference of results.content" [reference]="reference"></tr>
    </tbody>
  </table>

  <search-paging [searchComponent]="this"></search-paging>
</div>